module.exports = __webpack_public_path__ + "img/item-3.79dc055d.png";